<template>
<div style="height: 100%; position: relative;">
    <div id="d009" class="" style="position: absolute; top: 0; left: 0; right: 0; bottom: 40px;"></div>
    <div class="center" style="position: absolute; bottom: 0; left: 0; right: 0;">
		<span class="dot primary"></span> Totala tillgångar
		<span class="dot bcLightGrey"></span> Obeskattade reserver
		<span class="dot result"></span> Eget kapital
	</div>
</div>
</template>

<script>
    /* tslint:disable */
    import Highcharts from 'highcharts'
    import Vue from 'vue';
    import {colors} from '@/config';

    export default {
        name: "D009",
        components: {},
        props: {
            balance: Object
        },

        mounted() {
            this.chart = new Highcharts.chart({

                chart: {
                    type: 'column',
                    renderTo: 'd009',
                    backgroundColor: 'transparent',
                },

                credits: {
                    enabled: false,
                },
                
                title: {
                    text: ''
                },

                legend: {
                    enabled: false
                },

                colors: [colors.Primary, colors.LightGrey, colors.Green, colors.Red],

                xAxis: {
                    categories: this.balance.sheets.map( s => s.DATE_TO.substr(0, 4) ).reverse(),
                    labels: { 
                        style: { fontSize: '1.2rem', } 
                    } 
                },

                yAxis: {
                    opposite: true,
                    allowDecimals: false,
                    title: {
                        text: ''
                    },
                    labels: {
                        formatter() { return Vue.options.filters.KR(this.value); },
                        style: { fontSize: '1.2rem', } 
                    },
                    tickPixelInterval: 150
                },

                tooltip: {
                    formatter: function () {
                        return '<b>' + this.series.name + '<br>' + Vue.options.filters.TKR(this.y);
                    },
                    style: { fontSize: '1.5rem', } 
                },

                plotOptions: {
                    column: {
                        stacking: 'normal',
                                    borderColor: '#5d5d5d'
                    }
                },

                series: [{
                    name: 'Summa tillgångar',
                    data: this.balance.sheets.map( (s,i) => i === 0 ? {y: s.L, color: colors.Secondary} : s.L ).reverse(),
                    stack: 'intakt'
                }, {
                    name: 'Obeskattade reserver',
                    data: this.balance.sheets.map( s => s.N ).reverse(),
                    stack: 'kostnad'
                }, {
                    name: 'Eget kapital',
                    data: this.balance.sheets.map( s => s.M > 0 ? s.M : 0 ).reverse(),
                    stack: 'kostnad'
                }, {
                    name: 'Negativt eget kapital',
                    data: this.balance.sheets.map( s => s.M < 0 ? s.M : 0 ).reverse(),
                    stack: 'kostnad'
                }]
            });
        },

    }
</script>

<style scoped lang="scss">
    .dot {
        height: 20px;
        width: 20px;
        border-radius: 50%;
        display: inline-block;
    }

    .primary {
        background: linear-gradient( -45deg, get('colors.Secondary'), get('colors.Secondary') 50%, get('colors.Primary') 50%);
        border-radius: 50%;
    }

    .result {
        background: linear-gradient( -45deg, #e70407, #e70407 50%, #a4e408 50%);
        border-radius: 50%;
    }

    .center {
        font-size: 1.2rem;
    }
</style>
